import React from "react";

//import logo from "../assets/logo.svg";
import logo from "../assets/Fairplay_Logo_Primary_Black_Purple.svg";

const Hero = () => (
  <div className="text-center hero my-5">
    <img className="mb-3 app-logo" src={logo} alt="React logo" width="120" />
    <h1 className="mb-4">Data Upload Portal</h1>

    <p className="lead">
      Fairness Automation System
    </p>
  </div>
);

export default Hero;
